import React from 'react';
import PropTypes from 'prop-types';

import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';

import './Tag.scss';

const { block, element } = bem('hook-form-tag');

function Tag(props) {
  const { name, value, label, checked, disabled, handleChange } = props;

  return (
    <label className={block({ disabled })}>
      <input
        name={name}
        type="checkbox"
        value={value}
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        className={element('input', { disabled })}
      />
      <Message message={label} className={element('label', { disabled })} />
    </label>
  );
}

Tag.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([intlMessage, PropTypes.string]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default Tag;
